import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { FC } from 'react';
import { CiImageOn } from 'react-icons/ci';

import { DialogTitle } from '../../dialog-title';

type Props = {
  open: boolean;
  src: string;
  alt?: string;
  onClose: () => void;
};

export const ImagePreviewDialog: FC<Props> = ({ open, src, alt, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle icon={<CiImageOn />} onClose={onClose}>
        {alt ?? 'Image Preview'}
      </DialogTitle>
      <DialogContent sx={{ p: 1 }}>
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{ width: '100%', height: 'auto', maxHeight: '80vh', objectFit: 'contain', display: 'block' }}
        />
      </DialogContent>
    </Dialog>
  );
};
